import React, { useState, useEffect } from 'react';
import Chart from 'react-google-charts';
import Axios from 'axios';
import { Host } from '../App';
import { Button, Row, Col, Input, Select, Radio } from 'antd';
import './Dashboardnew.css';

const { Option } = Select;

const LineGraph = () => {
  const [filter, setFilter] = useState('weekly');
  const [partNo, setPartNo] = useState([]);
  const [weekPeriod, setWeekPeriod] = useState(1);
  const [startDate, setStartDate] = useState('2026-01-01');
  const [endDate, setEndDate] = useState(new Date().toISOString().slice(0, 10));
  const [operator, setOperator] = useState('');
  const [customer, setCustomer] = useState('');
  const [partInternalNo, setPartInternalNo] = useState('');
  const [station, setStation] = useState('');
  const [operators, setOperators] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [partDataset, setPartDataset] = useState([]);
  const [machineList, setMachineList] = useState([]);
  const [group, setGroup] = useState('Part_internalNo');
  const token = localStorage.getItem('acessToken');

  useEffect(() => {
    fetchData();
    fetchOperators();
    fetchCustomers();
    fetchPartDataset();
    fetchMachines();
  }, []);

  useEffect(() => {
    search();
  }, [operator, startDate, endDate, customer, partInternalNo, station, group]);

  const fetchData = async () => {
    try {
      const response = await Axios.get(`https://${Host}/realapi/getreport/searchgraph/${JSON.stringify(operator)},${startDate},${endDate},${JSON.stringify(customer)},${JSON.stringify(partInternalNo)},${JSON.stringify(station)},${token}`);
      setPartNo(response.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const fetchOperators = async () => {
    try {
      const response = await Axios.get(`https://${Host}/realapi/get/Operators/${token}`);
      setOperators(response.data);
    } catch (error) {
      console.error('Error fetching operators:', error);
    }
  };

  const fetchCustomers = async () => {
    try {
      const response = await Axios.get(`https://${Host}/realapi/get/Customers/${token}`);
      setCustomers(response.data);
    } catch (error) {
      console.error('Error fetching customers:', error);
    }
  };

  const fetchPartDataset = async () => {
    try {
      const response = await Axios.get(`https://${Host}/realapi/get/part_dataset/${token}`);
      setPartDataset(response.data);
    } catch (error) {
      console.error('Error fetching part dataset:', error);
    }
  };

  const fetchMachines = async () => {
    try {
      const response = await Axios.get(`https://${Host}/realapi/get/Machines/${token}`);
      setMachineList(response.data);
    } catch (error) {
      console.error('Error fetching machines:', error);
    }
  };

  const search = () => {
    fetchData();
  };

  const handleSelectChange = (value) => {
    const today = new Date();
    let startDate, endDate;

    switch (value) {
      case 'lastWeek':
        startDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
        endDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
        break;
      case 'thisWeek':
        startDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay());
        endDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + (6 - today.getDay()));
        break;
      case 'lastMonth':
        startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        endDate = new Date(today.getFullYear(), today.getMonth(), 0);
        break;
      case 'thisMonth':
        startDate = new Date(today.getFullYear(), today.getMonth(), 1);
        endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        break;
      case 'nextWeek':
        startDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + (7 - today.getDay()));
        endDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + (13 - today.getDay()));
        break;
      case 'nextMonth':
        startDate = new Date(today.getFullYear(), today.getMonth() + 1, 1);
        endDate = new Date(today.getFullYear(), today.getMonth() + 2, 0);
        break;
      default:
        return;
    }

    setStartDate(startDate.toISOString().slice(0, 10));
    setEndDate(endDate.toISOString().slice(0, 10));
  };

  const getFilteredData = () => {
    const data = [['x', 'SUM(Produced)']];
    const weekData = partNo.slice(-7 * weekPeriod);

    weekData.forEach((item) => {
      const date = new Date(item.Date);
      date.setDate(date.getDate() + 1);
      const label = `${date.getDate()} ${getMonthName(date.getMonth())}`;
      data.push([label, item['SUM(Produced)']]);
    });

    return data;
  };

  const getMonthName = (monthIndex) => {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return months[monthIndex];
  };

  return (
    <div className="linegraph-container">
      <h2 className="section-title">DAILY DATA RECORD LINE GRAPH</h2>

      <div className="filters-section">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={6}>
            <Input
              placeholder="Operator"
              list="operators"
              value={operator}
              onChange={(e) => setOperator(e.target.value)}
              className="filter-input"
            />
            <datalist id="operators">
              {operators.map((op, index) => (
                <option key={index} value={op.Morning_Operators} />
              ))}
            </datalist>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Select
              placeholder="Select Time Period"
              onChange={handleSelectChange}
              className="filter-select"
            >
              <Option value="lastWeek">Last Week</Option>
              <Option value="thisWeek">This Week</Option>
              <Option value="lastMonth">Last Month</Option>
              <Option value="thisMonth">This Month</Option>
              <Option value="nextWeek">Next Week</Option>
              <Option value="nextMonth">Next Month</Option>
            </Select>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="filter-input"
            />
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="filter-input"
            />
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Input
              placeholder="Customer"
              list="customers"
              value={customer}
              onChange={(e) => setCustomer(e.target.value)}
              className="filter-input"
            />
            <datalist id="customers">
              {customers.map((cust, index) => (
                <option key={index} value={cust.Customers} />
              ))}
            </datalist>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Input
              placeholder="Internal Part Number"
              list="internalPartNo"
              value={partInternalNo}
              onChange={(e) => setPartInternalNo(e.target.value)}
              className="filter-input"
            />
            <datalist id="internalPartNo">
              {partDataset.map((part, index) => (
                <option key={index} value={part.Part_internalNo} />
              ))}
            </datalist>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Input
              placeholder="Work Station"
              list="workStation"
              value={station}
              onChange={(e) => setStation(e.target.value)}
              className="filter-input"
            />
            <datalist id="workStation">
              {machineList.map((machine, index) => (
                <option key={index} value={machine.Machines} />
              ))}
            </datalist>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Input
              type="number"
              placeholder="Week Period"
              value={weekPeriod}
              onChange={(e) => setWeekPeriod(e.target.value)}
              className="filter-input"
              min="1"
            />
          </Col>
        </Row>

        <div className="radio-group">
          <Radio.Group
            value={group}
            onChange={(e) => setGroup(e.target.value)}
            buttonStyle="solid"
          >
            <Radio.Button value="Part_internalNo">Part Number</Radio.Button>
            <Radio.Button value="Operator">Operator</Radio.Button>
          </Radio.Group>
        </div>
      </div>

      <div className="chart-container">
        <Chart
          width={'100%'}
          height={'400px'}
          chartType="LineChart"
          loader={<div className="chart-loader">Loading Chart...</div>}
          data={getFilteredData()}
          options={{
            hAxis: {
              title: 'Date',
              titleTextStyle: { color: '#333', fontSize: 14 },
              textStyle: { color: '#666' },
            },
            vAxis: {
              title: 'SUM(Produced)',
              titleTextStyle: { color: '#333', fontSize: 14 },
              textStyle: { color: '#666' },
              minValue: 0,
            },
            series: {
              0: {
                curveType: 'function',
                color: '#1890ff',
                lineWidth: 3,
              },
            },
            legend: { position: 'none' },
            backgroundColor: 'transparent',
            chartArea: {
              width: '85%',
              height: '75%',
              backgroundColor: {
                stroke: '#e6f7ff',
                strokeWidth: 1
              }
            },
            tooltip: {
              textStyle: { fontSize: 14 },
              showColorCode: true
            },
            animation: {
              startup: true,
              duration: 1000,
              easing: 'out',
            },
            interpolateNulls: true,
          }}
        />
      </div>

      <div className="chart-actions">
        <Button
          type="primary"
          size="large"
          onClick={() => window.location.href = '/Morning'}
          className="proceed-btn"
        >
          Proceed To Enter Data
        </Button>
      </div>
    </div>
  );
};

export default LineGraph;